import { render, staticRenderFns } from "./ProfileForm.vue?vue&type=template&id=fb61c2c2"
import script from "./ProfileForm.vue?vue&type=script&lang=js"
export * from "./ProfileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports